/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_OccupationInputs */

const en__field_occupation = /** @type {(inputs: _Field_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working as`)
};

const de__field_occupation = /** @type {(inputs: _Field_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschäftigt als`)
};

/**
* | output |
* | --- |
* | "Working as" |
*
* @param {_Field_OccupationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_occupation = /** @type {((inputs?: _Field_OccupationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_OccupationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_occupation(inputs)
	return de__field_occupation(inputs)
});